// extracted by mini-css-extract-plugin
module.exports = {"city-card":"Citycard_city-card__3_idB","city-name":"Citycard_city-name__2w_oa","city-jobs":"Citycard_city-jobs__6R8UM"};